import { ReactNode } from "react";

interface ReportCardProps {
  title: string;
  subtitle?: string;
  /** Right-aligned header content, e.g. a hint or a legend. */
  headerActions?: ReactNode;
  children: ReactNode;
  /** Set false when the child renders its own edge-to-edge padding, e.g. a table. */
  padded?: boolean;
}

const ReportCard = ({
  title,
  subtitle,
  headerActions,
  children,
  padded = true,
}: ReportCardProps) => (
  <section className="admin-report__card">
    <div className="admin-report__card-header">
      <div>
        <div className="admin-report__card-title">{title}</div>
        {subtitle && (
          <div className="admin-report__card-subtitle">{subtitle}</div>
        )}
      </div>
      {headerActions}
    </div>
    {padded ? (
      <div className="admin-report__card-body">{children}</div>
    ) : (
      children
    )}
  </section>
);

export default ReportCard;
